/**
 * @generated SignedSource<<7bfe2e5807960117138aeaed1e7d88de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditMainAccomodation_order$data = {
  readonly hotelName: string | null;
  readonly hotelStars: number | null;
  readonly " $fragmentType": "OrderEditMainAccomodation_order";
};
export type OrderEditMainAccomodation_order$key = {
  readonly " $data"?: OrderEditMainAccomodation_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditMainAccomodation_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditMainAccomodation_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hotelName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hotelStars",
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "4528b20328b656de9478994f588ea645";

export default node;
